module.exports = __webpack_public_path__ + "img/check.f7d0ccc7.png";